import { FC } from "react";
import SimpleList from "./simple-list";

interface SimpleLogBookProps {
  logItems: LogItem[];
  title?: string;
  subTitle?: string;
  onClick?: (item: LogItem) => void;
}

const SimpleLogBook: FC<SimpleLogBookProps> = ({
  logItems,
  title,
  subTitle,
  onClick,
}) => {
  const handleItemClick = (itemIndex: number) => {
    if (logItems[itemIndex]?.link) {
      onClick?.(logItems[itemIndex]);
    }
  };

  return (
    <>
      {title && <h5 className="">{title}</h5>}
      {subTitle && <small className="text-muted">{subTitle}</small>}
      <SimpleList
        className="mt-3"
        items={(logItems ?? []).map(
          (item) => item.timestamp + " - " + item.content
        )}
        onItemClick={handleItemClick}
      />
    </>
  );
};

export default SimpleLogBook;
